import { Button } from '@pega/cosmos-react-core';

export interface DemoFormField {
  name: string;
  label: string;
  info: string;
  value: string;
  validator: (value: string) => boolean;
}

export const demoFields = [
  {
    name: 'field-1',
    label: 'Field 1',
    info: 'Hint: type exact label text above',
    value: '',
    validator: (value: string) => value === 'Field 1'
  },
  {
    name: 'field-2',
    label: 'Field 2',
    info: 'Hint: type exact label text above',
    value: '',
    validator: (value: string) => value === 'Field 2'
  },
  {
    name: 'field-3',
    label: 'Field 3',
    info: 'Hint: type exact label text above',
    value: '',
    validator: (value: string) => value === 'Field 3'
  }
];

export const formActions = (
  <>
    <Button name='Cancel' variant='secondary'>
      Cancel
    </Button>
    <Button name='Submit' type='submit' variant='primary'>
      Submit
    </Button>
  </>
);

// Handles setting of state for all fields
export const fieldReducer = (fields: DemoFormField[], inputEl: { name: string; value: string }) => {
  return fields.map(field => {
    if (inputEl.name === field.name) {
      field.value = inputEl.value;
    }
    return field;
  });
};
